module.exports = __webpack_public_path__ + "img/logo-1-en.36870587.png";